import { nanoid } from "nanoid"
import ArchivosAdjuntosDropzone from "../ArchivosAdjuntosDropzone"
import ArchivosAdjuntosFileItem from "../ArchivosAdjuntosFileItem"

const ModalVerDocumentoArchivosAdjuntos = ({
  archivosAdjuntos,
  agregarArchivoAdjunto,
  eliminarArchivoAdjunto,
  descargarArchivoAdjunto,
  isVentaBorrador = false,
}: $TSMigrationFixMe) => {
  return (
    <>
      {!isVentaBorrador && (
        <div className='mb-3'>
          <ArchivosAdjuntosDropzone
            handleUpload={agregarArchivoAdjunto}
            multiple={false}
            maxFiles={1}
          />
        </div>
      )}

      {archivosAdjuntos?.map((archivoAdjunto: $TSMigrationFixMe) => (
        <ArchivosAdjuntosFileItem
          key={nanoid()}
          name={archivoAdjunto.nombre}
          size={archivoAdjunto.tamañoEnBytes}
          onDelete={() => eliminarArchivoAdjunto(archivoAdjunto.id)}
          onDownload={() => descargarArchivoAdjunto(archivoAdjunto)}
        />
      ))}
    </>
  )
}

export default ModalVerDocumentoArchivosAdjuntos
